// extracted by mini-css-extract-plugin
export default {"input":"C9-z","button":"D9-z","selected":"E9-z","unavailable":"F9-z","oos":"G9-z","image":"H9-z","paperCutDisabledOverlay":"I9-z"};